/*
 * Fades each section up as it scrolls into view.
 *
 * Only sections that start below the fold are touched, so the hero and
 * anything else visible on load paint immediately. Sections in the footer
 * group are skipped: the transform used for the animation would break the
 * floating WhatsApp button's fixed position while it runs.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var REVEAL = 'section-reveal';
  var REVEALED = 'is-revealed';

  function sections() {
    return Array.prototype.filter.call(
      document.querySelectorAll('.shopify-section'),
      function (section) {
        if (section.closest('.shopify-section-group-header-group')) return false;
        if (section.closest('.shopify-section-group-footer-group')) return false;
        if (section.querySelector('cart-drawer, .ai-whatsapp-float')) return false;
        // The scroll gallery pins itself to the viewport; a transform on the
        // section would move the goalposts for its sticky stage.
        if (section.querySelector('[data-scroll-gallery]')) return false;
        return section.getBoundingClientRect().top > window.innerHeight * 0.9;
      }
    );
  }

  function start() {
    var targets = sections();
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add(REVEALED);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.04 }
    );

    // Hide only once the observer exists, so a section can never be left
    // hidden with nothing watching it.
    targets.forEach(function (section) {
      section.classList.add(REVEAL);
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // The theme editor re-renders sections; reveal whatever it adds.
  document.addEventListener('shopify:section:load', function (event) {
    event.target.classList.add(REVEAL, REVEALED);
  });
})();
